import useDefinedContext from "hooks/useDefinedContext";
import ChartSelectionsContext from "components/charting/contexts/ChartSelectionsContext";

function useChartSelections() {
  return useDefinedContext(ChartSelectionsContext);
}
export default useChartSelections;
